module.exports = __webpack_public_path__ + "static/scale-model-of-old-governor's-mansion-in-baton-rouge-louisiana-14afc908e321da66acf33ce8b1a86bab.png";